// extracted by mini-css-extract-plugin
export default {"scoreInfo":"AdminCampaignForm__scoreInfo-JYNvE"};